import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "galleryOpen",
  "use": "galleryOpen-usage",
  "viewBox": "0 0 27.7 27.7",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27.7 27.7\" id=\"galleryOpen\">\n  <style>\n    #galleryOpen .st0{fill:none;stroke:#F2F2ED;stroke-miterlimit:10}\n  </style>\n  <path class=\"st0\" d=\"M5 26.5h8M26.5 13V5M14 .5h12.5l-26 26V14\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol